import { render, staticRenderFns } from "./StoryPreview.vue?vue&type=template&id=5dfc53e9&scoped=true&"
import script from "./StoryPreview.vue?vue&type=script&lang=js&"
export * from "./StoryPreview.vue?vue&type=script&lang=js&"
import style0 from "./StoryPreview.vue?vue&type=style&index=0&id=5dfc53e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc53e9",
  null
  
)

export default component.exports